import { combineReducers } from 'redux';
import { search } from './reducers/searchActionReducers';
import { photos } from './reducers/photosActionReducers';
import { windowState } from './reducers/windowStateActionReducers';

const flickrCombinedReducers = combineReducers({
	search: search,
	photos: photos,
	windowState: windowState
});

export { flickrCombinedReducers };



/** WEBPACK FOOTER **
 ** ./src/flickr-redux/reducers.js
 **/